var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "flex-row": _vm.collection === "a" } },
    [
      _c(
        "vue-content-loading",
        {
          staticClass: "collection-filters-skeleton",
          class: {
            "collection-filters-skeleton--full": _vm.collection === "a"
          },
          attrs: { width: 188, height: 20 }
        },
        [
          _c("rect", {
            attrs: { x: "0", y: "0", width: "100%", height: "100%" }
          })
        ]
      ),
      _c(
        "vue-content-loading",
        {
          staticClass: "collection-filters-skeleton",
          class: {
            "collection-filters-skeleton--full": _vm.collection === "a"
          },
          attrs: { width: 188, height: 20 }
        },
        [
          _c("rect", {
            attrs: { x: "0", y: "0", width: "100%", height: "100%" }
          })
        ]
      ),
      _c(
        "vue-content-loading",
        {
          staticClass: "collection-filters-skeleton",
          class: {
            "collection-filters-skeleton--full": _vm.collection === "a"
          },
          attrs: { width: 188, height: 20 }
        },
        [
          _c("rect", {
            attrs: { x: "0", y: "0", width: "100%", height: "100%" }
          })
        ]
      ),
      _c(
        "vue-content-loading",
        {
          staticClass: "collection-filters-skeleton",
          class: {
            "collection-filters-skeleton--full": _vm.collection === "a"
          },
          attrs: { width: 188, height: 20 }
        },
        [
          _c("rect", {
            attrs: { x: "0", y: "0", width: "100%", height: "100%" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }